module.exports = __webpack_public_path__ + "static/media/blog14.7a737899.svg";